import {useOpen} from 'common/hooks'
import {Modal} from 'common/components'
import {Button} from 'common/components/V2'
import UserForm from './UserForm'

interface Content {
  buttonLabel: string
  modalTitle: string
  Form: any
}

const TheContent: Content = {
  buttonLabel: 'user',
  modalTitle: 'User',
  Form: UserForm,
}

export const AddButton = () => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  const {Form} = TheContent

  return (
    <>
      <Button $color='cyan' $size="small" onClick={handleOpen}>
        add {TheContent.buttonLabel}
      </Button>
      <Modal
        title={`New ${TheContent.modalTitle}`}
        open={isOpen}
        onCancel={handleClose}
      >
        <Form onClose={handleClose} />
      </Modal>
    </>
  )
}
